export default {
	verify: {
		title: "Vérification en deux étapes",
		totpHint: "Saisissez le code à 6 chiffres de votre application d'authentification.",
		emailHint: "Nous avons envoyé un code à 6 chiffres à votre adresse e-mail.",
		backupHint: "Saisissez l'un de vos codes de secours.",
		codeLabel: "Code de vérification",
		backupLabel: "Code de secours",
		rememberDevice: "Se souvenir de cet appareil pendant 30 jours",
		submit: "Vérifier",
		invalidCode: "Code invalide ou expiré. Veuillez réessayer.",
		resend: "Renvoyer le code",
		resending: "Envoi en cours...",
		resent: "Code renvoyé à votre adresse e-mail",
		resendError: "Impossible de renvoyer le code",
		useBackup: "Utiliser un code de secours",
		useCodeInstead: "Utiliser le code de l'application",
		back: "Retour à la connexion",
	},
	settings: {
		title: "Vérification en deux étapes",
		description:
			"Ajoutez une couche de sécurité supplémentaire à votre compte en exigeant un code en plus du mot de passe lors de la connexion.",
		enabled: "Vérification en deux étapes activée",
		disabled: "Vérification en deux étapes désactivée",
		disabledHint: "Votre compte est protégé uniquement par votre mot de passe.",
		methodLabel: "Méthode",
		backupRemaining: "{count} code(s) de secours restant(s)",
		activate: "Activer",
		regenerate: "Régénérer les codes de secours",
		disable: "Désactiver",
	},
	methods: {
		totp: "Application d'authentification",
		totpDesc: "Utilisez Google Authenticator, Authy ou similaire (recommandé).",
		email: "Code par e-mail",
		emailDesc: "Recevez un code par e-mail à chaque connexion.",
	},
	activate: {
		title: "Activer la vérification en deux étapes",
		chooseMethod: "Choisissez comment vous souhaitez recevoir les codes de vérification.",
		continueBtn: "Continuer",
		totpScan:
			"Scannez le QR code avec votre application d'authentification et saisissez le code généré.",
		totpManual: "Ou saisissez cette clé manuellement :",
		qrAlt: "QR code pour la configuration de l'authentificateur",
		emailSent: "Nous avons envoyé un code de vérification à votre adresse e-mail.",
		confirm: "Activer",
	},
	backup: {
		title: "Codes de secours",
		warning:
			"Conservez ces codes en lieu sûr. Chaque code peut être utilisé une seule fois pour vous connecter si vous perdez l'accès à votre méthode principale. Ils ne seront plus affichés.",
		copy: "Copier",
		download: "Télécharger",
		saved: "J'ai enregistré mes codes",
		fileHeader: "Codes de secours de la vérification en deux étapes — ORI",
	},
	disable: {
		title: "Désactiver la vérification en deux étapes",
		description:
			"Pour confirmer, saisissez un code de votre méthode de vérification ou un code de secours.",
		codeLabel: "Code de vérification ou de secours",
	},
	regenerate: {
		title: "Régénérer les codes de secours",
		warning:
			"En générant de nouveaux codes, vos codes de secours précédents cesseront de fonctionner.",
		confirm: "Générer de nouveaux codes",
	},
	devices: {
		title: "Appareils de confiance",
		empty: "Aucun appareil de confiance",
		emptyHint:
			"Les appareils mémorisés lors de la connexion apparaissent ici et ne demandent pas de code pendant 30 jours.",
		unknownDevice: "Appareil inconnu",
		lastUsed: "Dernière utilisation",
		never: "Jamais",
		expires: "Expire le",
		revoked: "Appareil révoqué",
		revokeError: "Impossible de révoquer l'appareil",
	},
	reminder: {
		title: "Protégez votre compte",
		text: "Activez la vérification en deux étapes pour une couche de sécurité supplémentaire à la connexion.",
		activate: "Activer maintenant",
		dismiss: "Ignorer",
	},
	messages: {
		statusError: "Impossible de charger l'état de la vérification en deux étapes",
		setupError: "Impossible de démarrer la configuration",
		activated: "Vérification en deux étapes activée avec succès",
		invalidCode: "Code invalide. Veuillez vérifier et réessayer.",
		copied: "Copié dans le presse-papiers",
		copyError: "Impossible de copier",
		disabled: "Vérification en deux étapes désactivée",
		regenerated: "Nouveaux codes de secours générés",
		regenerateError: "Impossible de régénérer les codes de secours",
	},
};
